

import { Autocomplete, Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from '@mui/material';
// import { OrganizationChart } from 'primereact/organizationchart';
import { useEffect, useRef, useState } from 'react'

import "./index.css"
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { getOfficesByCompanyRuc } from '../../api/s10OrganizationApi';
import { ApprovalEmployees, ApprovalGroupsCompanies } from '../../interfaces/auth.interface';
import { Employee, Office } from '../../interfaces/s10Corporation.interface';

import { NodeAddOption, NodeEmployee, NodeOrgnization } from './nodes';
import { getEmployeesAdditionalDataByIdForOrganigram } from '../../api/signalApi'; // getEmployeesAdditionalDataById
import { APPROVAL_EMPLOYEES } from '../../constants/signalRequestConsts';
import AddNodeModal from './addNodeModal';
// import { useCenteredTree } from './helpers';
import DeleteNodeModal from './deleteNodeModal';
import { searchApprovalGroupsCompanies } from '../../store/slices/userRequests';
import { OrganizationChart } from 'primereact/organizationchart';
import Draggable from './draggable';
import { classNames } from 'primereact/utils';
import EditNodeModal from './editNodeModal';


const SearchInputGrid = ({data, setSelectedUser}: {data: ApprovalEmployees[], setSelectedUser: (node: ApprovalEmployees) => void}) => {
    // const classes = useStyles();

    const handleSetSelectedUser = (value: ApprovalEmployees["Descripcion"] | null) => {
        const employee = data.find(e => e.Descripcion === value);
        setSelectedUser(employee as any)
    }
  
    return (
        <Grid 
            container
            direction="row"
            // justifyContent="flex-end"
            alignItems="center"
            sx={{
                position: 'fixed', 
              //   top: "7rem", 
                width: '100%', 
                zIndex: 999,
            }}
        >
            
            <Grid 
                item
                xs={8} sm={4}
            >
            <Autocomplete
                id="free-solo-demo"
                size="small"
                freeSolo
                sx={{
                    w: {xs: "60rem", md: "80rem"},
                    position: 'relative',
                    top: 0, 
                }}
                onChange={(event, value: ApprovalEmployees["Descripcion"] | null) => handleSetSelectedUser(value)}
                style={{backgroundColor: "white"}}
                options={data.map((option) => option.Descripcion)}
                renderInput={(params) => <TextField {...params} label="Buscar" />}
            />
            </Grid>
        </Grid>
    );
};

type Action = "employees" | "offices";
interface BuildTemplateProps {
    offices: Office[];
    parent?: Office;
    parents?: Office['Id'][];
    isAdmin?: boolean;
    openedNodes?: {[key: string]: Action};
    selectedEmployee?: Employee['EmployeeCode'];
}

interface HandleStar {
    offices: Office[];
    isAdmin: boolean;
    openedNodes?: {[key: string]: Action};
}

export interface NewNodeData {
    success: boolean,
    message: string,
    employeeData?: Employee, 
    officeData?: Office, 
    action: Action
}

export interface DeleteNodeData {
    success: boolean,
    message: string,
    employeeIds?: Employee['EmployeeCode'][], 
    officeIds?: Office['Id'][],
    parentId?: Office['Id'],
}


const Organization = () => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {employees, companies, companiesIsLoading} = useSelector((state: RootState) => state.userRequests).approvalGroups;
        
    const containerRef = useRef<HTMLDivElement>(null);
    //   const [dimensions, translate] = useCenteredTree(containerRef);


    const [tree, setTree] = useState<Office[]>([]);
    const [originalData, setOriginalData] = useState<Office[]>([]);
    const [openedNodes, setOpenedNodes] = useState<{[key: string]: Action}>({});
    // const [searchData, setSearchData] = useState([]);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    const [isLoadingOffices, setIsLoadingOffices] = useState<boolean>(false);

    const [nodeAction, setNodeAction] = useState<"Agregar" | "Eliminar" | "Modificar" | null>(null);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [parentData, setParentData] = useState<Office | null>(null);
    const [officeToDelete, setOfficeToDelete] = useState<Office | null>(null);
    const [officeToEdit, setOfficeToEdit] = useState<Office | null>(null);
    const [employeeToDelete, setEmployeeToDelete] = useState<Employee | null>(null);

    
    useEffect(() => {
        if (!connectionId || !companyselected?.Token || companies.length > 0 || companiesIsLoading ) {
            return;
        }
        dispatch(searchApprovalGroupsCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])

    useEffect(() => {
        if (!companies?.length) {
            return;
        }
        const currentCompany = companies.find((c: ApprovalGroupsCompanies) => c?.RUC as any === companyselected?.RUC)
        const finalSelected = currentCompany ? currentCompany.RUC : companies[0].RUC
        setSelectedCompany(finalSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies])

    useEffect(() => {
        if (!connectionId || !companyselected?.Token || !selectedCompany || isLoadingOffices) {
            return;
        }
        handleSearchOffices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany])

    const handleOpenNode = (openedNodes: {[key: string]: Action}, nodeId: Office['Id'], action: Action) => {
        let copyOpenedNodes = {...openedNodes};
        if (copyOpenedNodes[nodeId] !== action) {
            copyOpenedNodes[nodeId] = action;
        } else {
            delete copyOpenedNodes[nodeId];
        }
        setOpenedNodes(copyOpenedNodes);
        return copyOpenedNodes;
    }

    const handleSearchOffices = async () => {
        if (isLoadingOffices || companies.length === 0 || !selectedCompany) {
            return;
        }
        setTree([])
        setOriginalData([])
        setOpenedNodes({});
        setIsLoadingOffices(true);
        const resp = await getOfficesByCompanyRuc(selectedCompany);
        const isAdmin = window.location.pathname.includes("administracion");
        let data = [];
        if (resp?.data?.length) {
            data = resp.data.map((d: any) => ({...d, id: d.Id,}))
            const employeesCodes = (resp.data as Office[])
                                .filter(o => !!o.Employees?.length)
                                .map(o => o.Employees?.map(c => c.EmployeeCode).join("|"))
                                .join("|");
            getEmployeesAdditionalDataByIdForOrganigram(APPROVAL_EMPLOYEES, employeesCodes);
        }
        
        const parent = {
            id: null,
            Id: null,
            Name: companies.find(c => c.RUC === selectedCompany)?.Descripcion,
        }
        const finalData = [parent, ...data];
        setIsAdmin(isAdmin)
        setOriginalData(finalData);
        setIsLoadingOffices(false);
    }

    useEffect(() => {
        if (!originalData?.length) {
            return;
        }
        handleStar({offices: originalData, isAdmin: isAdmin, openedNodes});

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [originalData, isAdmin, openedNodes])

    const addOption = (nodeParent: Office): Office => {
        return {
            Id: new Date().getUTCSeconds(),
            parentData: nodeParent,
            isAddOption: true,
            onClickAddOption: () => {
                setNodeAction("Agregar");
                setParentData(nodeParent);
            }
        } as any
    }

    const buildTree = ({offices=[], parent, parents=[], openedNodes={}, selectedEmployee, isAdmin}: BuildTemplateProps): any => {
        if (offices.length === 0) {
            return {
                tree: [], 
                dataWithParents: [],
            };
        }
        const newTree = [];
        let dataWithParents = [];
        const childrenNodes = offices.filter((n: Office) => n.ParentId === parent?.Id);

        for (let i = 0; i < childrenNodes.length; i++) {
            const node: any = childrenNodes[i];
            if (parent) {
                node.parentData = {
                    name: parent?.Name,
                };
            }
            node.parents = parents || [];
            dataWithParents.push(node);
            const nodeChildren = buildTree({
                offices, 
                parent: node, 
                parents: [...parents, node.Id],
                isAdmin,
                openedNodes,
                selectedEmployee,
            });
            node.children = [];
            // node.expanded = true;
            // node.children = [{hidden: true}];
            node.offices = [];
            if (nodeChildren?.tree?.length) {
                dataWithParents = [...dataWithParents, ...nodeChildren.dataWithParents]
                node.offices = nodeChildren.tree
            }
            if (isAdmin) {
                node.offices.push(addOption(node));
            }
            node.principalEmployee = node.Employees?.find((e: any) => e.IsPrincipal === true);
            if (openedNodes[node.Id]) {
                // node.collapsed = false;
                const action = openedNodes[node.Id];
                if (action === "employees") {                    
                    node.employeesGroup = prepareEmployeesGroup(node, selectedEmployee);
                    node.children = node.employeesGroup;
                    
                } else {
                    node.children = node.offices;
                }
                node.currentChildView = action;
            } else {
                node.currentChildView = null;
                node.children = [{hidden: true, parentId: node.Id}];
            }
            newTree.push(node);
        }
        return {tree: newTree, dataWithParents};
    }

    const handleStar = ({offices, isAdmin, openedNodes}: HandleStar) => {
        const finalNodes = buildTree({offices, isAdmin, openedNodes });
        // setSearchData(finalNodes.dataWithParents);
        setTree(finalNodes.tree);
    }

    const handleSetSelectedUser = (employee: ApprovalEmployees | undefined) => {        
        const selectedUser: any = originalData.find((sd) => sd.Employees?.find( e => e.EmployeeCode === employee?.CodIdentificador));
        if (!selectedUser) {
            return;
        }
        const nodesToOpen = (selectedUser?.parents || []);
        let copyOpenedNodes: {[key: string]: Action} = {}
        for (let i = 0; i < nodesToOpen.length; i++) {
            copyOpenedNodes[nodesToOpen[i]] = "offices";
            
        }
        copyOpenedNodes[selectedUser.Id] = "employees";
        setOpenedNodes(copyOpenedNodes);
        const finalNodes = buildTree({offices: originalData, openedNodes: copyOpenedNodes, selectedEmployee: employee?.CodIdentificador});
        setTree(finalNodes.tree);
    }

    const handleSetNewNodeResult = ({success, employeeData, officeData, action}: NewNodeData) => {
        if (success) {
            const nodeData = employeeData || officeData;
            changeChildren(nodeData as any, action, employeeData, officeData)
        }
        setNodeAction(null);
        setParentData(null)
    }

    const handleDeleteNodeResult = ({success, parentId, employeeIds, officeIds}: DeleteNodeData) => {
        let offices = [...originalData];
        if (success) {
            if (officeIds?.length) {
                offices = offices.filter(o => !officeIds.includes(o.Id));
            }
            if (employeeIds?.length) {
                const index = offices.findIndex(o => o.Id === parentId);
                const employees = offices[index].Employees;
                offices[index].Employees = employees?.filter(e => !employeeIds.includes((e as any).Id));
            }
            setOriginalData(offices);
        }
        setOfficeToDelete(null);
        setEmployeeToDelete(null);
    }

    const prepareEmployeesGroup = (node: Office, selectedEmployee?: Employee['EmployeeCode']): Employee[][] => {
        let employeesGroup: Employee[][] = []
        if (node.Employees?.length) {
            let coll = [];
            // const principal = node.Employees.find(e => e.IsPrincipal === true);
            const employees = (node.Employees || [])
                                // .filter((e: any) => e.IsPrincipal !== true)
                                .map((e: any) => ({...e, parents: node.parents, parentData: node}))
                                .sort((a, b) => {
                                    if (a.IsPrincipal && !b.IsPrincipal) return -1;
                                    if (!a.IsPrincipal && b.IsPrincipal) return 1;
                                    return 0;
                                });;
            for (let ii = 0; ii < employees.length; ii++) {
                const collaborator = employees[ii];
                coll.push({
                    ...collaborator,
                    isSelected: selectedEmployee === collaborator.EmployeeCode
                });
                if (coll.length === 3 || (ii + 1) === employees.length) {
                    employeesGroup.push(coll);
                    coll = [];
                }
            }
        }
        if (isAdmin) {
            employeesGroup.push(addOption(node) as any);
        }
        return employeesGroup;
    }

    const changeChildren = (node: Office, action: Action, newEmployee?: Employee, newOffice?: Office,) => {
        handleOpenNode(openedNodes, node.Id, action);
        const offices = [...originalData];
        if (newEmployee) {
            const index = offices.findIndex( o => o.Id === newEmployee.parentData?.Id);
            if (index) {
                const employees = offices[index].Employees || [];
                employees.push(newEmployee);
                offices[index].Employees = employees;
            }
        }
        if (newOffice) {
            offices.push(newOffice)
        }
        setOriginalData(offices);
    }

    const editOffice = (editedOffice: Office) => {
        const offices = [...originalData].map(office => {
            if (office.Id !== editedOffice.Id) {
                return office;
            }
            return {
                ...office,
                ...editedOffice
            }
        });

        setOriginalData(offices);
    }

    return (
        <Grid
            item
            width="100%"
            marginTop="1.5rem"
            height="100%"
            position="relative"
            container
            direction="column" // Para que los elementos se apilen verticalmente
            style={{ display: "flex" }}
        >
            <Grid container style={{marginBottom: "1rem"}}>
                <Grid item>
                    <FormControl style={{minWidth: "15rem"}}>
                        <InputLabel id="select-option-label">Empresa</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label={"Empresa"}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setSelectedCompany(value);
                            }}
                            value={String(selectedCompany)}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white",}}
                        >
                            {companies?.map((item, i) => (
                                <MenuItem
                                    key={i} 
                                    value={item.RUC}
                                >
                                    {item.Descripcion}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            
            <Paper 
                elevation={3}
                style={{
                    width: "100%",
                    borderRadius: "0.5rem",
                    overflowX: "auto",
                    overflowY: "auto",
                    height: "100%",
                    position: "relative",
                    // maxHeight: "75vh"
                }}
            >

            <SearchInputGrid data={employees} setSelectedUser={handleSetSelectedUser} />
            {/* <div style={{ width: '100%', height: '80vh', }} ref={containerRef}> */}
            <Draggable innerRef={containerRef} style={{ width: '100%', overflowY: "auto", }}>
                
            {tree?.length > 0 && <OrganizationChart 
                value={tree as any}
                style={{marginTop: "2rem"}}
                nodeTemplate={(userData: any) => {
                    if (userData.hidden) {
                        return <Box
                            className={classNames(
                                'div-hidden',
                                `parent-${userData.parentId}-child`
                            )}
                            sx={{
                            height: '5rem',
                            width: '5rem',
                            position: 'relative',
                            top: '-2.5rem',
                            backgroundColor: 'white',
                            }}
                        />;
                    }
                    return userData.isAddOption === true
                        ? <NodeAddOption
                            nodeDatum={userData as any} 
                            toggleNode={() => {}}
                            isAdmin={isAdmin}
                        />
                        : userData.length
                            ? <NodeEmployee
                                // key={`${e.EmployeeCode}`}
                                // nodeDatum={userData.filter((e: any) => e.IsPrincipal !== true)}
                                nodeDatum={userData}
                                toggleNode={() => {}}
                                // drawLine={(i + 1) < nodeDatum.length}
                                isAdmin={isAdmin}
                                setNodeToDelete={setEmployeeToDelete}
                            />
                            : <NodeOrgnization 
                                nodeDatum={userData as any} 
                                toggleNode={() => {}}
                                changeChildren={changeChildren}
                                isAdmin={isAdmin} 
                                setNodeToDelete={setOfficeToDelete}
                                setNodeToEdit={setOfficeToEdit}
                            />
                }} 
            />}
            </Draggable>
            </Paper>

            {officeToEdit?.Id &&
                <EditNodeModal 
                    nodeData={officeToEdit}
                    onCancel={() => {
                        setOfficeToEdit(null);
                    }}
                    setEditedNodeData={editOffice}
                />
            }
            {nodeAction === "Agregar" && parentData &&
                <AddNodeModal 
                    company={companies.find(c => c.RUC === selectedCompany) as any}
                    nodesData={originalData}
                    nodeAction={nodeAction}
                    parentData={parentData}
                    onCancel={() => {
                        setNodeAction(null);
                        setParentData(null)
                    }}
                    setNewNodeResult={handleSetNewNodeResult}
                />
            }
            {(officeToDelete || employeeToDelete) &&
                <DeleteNodeModal 
                    company={companies.find(c => c.RUC === selectedCompany) as any}
                    officeData={officeToDelete}
                    employeeData={employeeToDelete}
                    onCancel={() => {
                        setOfficeToDelete(null);
                        setEmployeeToDelete(null);
                    }}
                    setDeletedNode={handleDeleteNodeResult}
                />
            }
        </Grid>
    )
}

export default Organization